module.exports = " <div class=fish> <img :src=\"fish | fishImg\"/><br> <span>{{fish[lang]}}</span> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fish.vue
 ** module id = 46
 ** module chunks = 1
 **/